import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from './presentation/redux/store'

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

if(process.env.REACT_APP_ENVIRONMENT == "production") {
  //hotjar
  const scriptHotjar = document.createElement("script");
  scriptHotjar.setAttribute("src", "js/hotjar.js");
  document.body.appendChild(scriptHotjar);
  //clarity
  const scriptClarity = document.createElement("script");
  scriptClarity.setAttribute("src", "js/clarity.js");
  document.body.appendChild(scriptClarity);

}

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
